<!--
 - Order item holes
 -
 - @author Erik Orozco <erik.orozco@buildcentrix.com>
 - @copyright (c) 2025 Build Centrix
 -->
<div class="order-item-holes">
  <bc-templates-modal-layout
    [isLoading]="isLoading"
    [loadingText]="('actions.loading'|translate)"
    (onCloseButtonClicked)="onDismiss()"
  >
    <!--Dialog Title-->
    <div title-content>
      <div>
        <span
          >{{'orderItemHoles.title'|translate}}: #{{ data.referenceNumber }}
          -</span
        >
        {{data.label}}
      </div>
    </div>
    <!--Dialog Content-->
    <div body-content>
      <!--Content-->
      <div class="bcx-modal-content">
        <div class="bcx-modal-content-container">
          <div class="row">
            <!--Products (non-fittings) Table-->
            <div class="col-12 items-table">
              <div class="no-more-tables">
                <bc-templates-table-container
                  class="order-item-holes-table"
                  [dataSource]="dataSource"
                  [headers]="orderItemHoleColumns"
                  [showPagination]="false"
                  [isLoading]="isLoading"
                  [customColSpan]="orderItemHoleColumns.length"
                  [paginationPageSize]="dataSource?.data?.length"
                  matSort
                >
                  <!--Hole #-->
                  <ng-container matColumnDef="number">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.number.description'|translate}}"
                    >
                      {{'orderItemHoles.number.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.number.description'|translate}}"
                    >
                      <span class="text-info">
                        {{element['number']}}
                      </span>
                    </td>
                  </ng-container>

                  <!--Type-->
                  <ng-container matColumnDef="type">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.type.description'|translate}}"
                    >
                      {{'orderItemHoles.type.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.type.description'|translate}}"
                    >
                      {{element['type']}}
                    </td>
                  </ng-container>

                  <!--inset-->
                  <ng-container matColumnDef="inset">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.inset.description'|translate}}"
                    >
                      {{'orderItemHoles.inset.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.inset.description'|translate}}"
                    >
                      {{element['inset']}}
                    </td>
                  </ng-container>

                  <!--offset-->
                  <ng-container matColumnDef="offset">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.offset.description'|translate}}"
                    >
                      {{'orderItemHoles.offset.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.offset.description'|translate}}"
                    >
                      {{element['offset']}}
                    </td>
                  </ng-container>

                  <!--rotation-->
                  <ng-container matColumnDef="rotation">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.rotation.description'|translate}}"
                    >
                      {{'orderItemHoles.rotation.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.rotation.description'|translate}}"
                    >
                      {{element['rotation']}}
                    </td>
                  </ng-container>

                  <!--angle-->
                  <ng-container matColumnDef="angle">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.angle.description'|translate}}"
                    >
                      {{'orderItemHoles.angle.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.angle.description'|translate}}"
                    >
                      {{element['angle']}}
                    </td>
                  </ng-container>

                  <!--side-->
                  <ng-container matColumnDef="side">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.side.description'|translate}}"
                    >
                      {{'orderItemHoles.side.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.side.description'|translate}}"
                    >
                      {{element['side']}}
                    </td>
                  </ng-container>

                  <!--width-->
                  <ng-container matColumnDef="width">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.width.description'|translate}}"
                    >
                      {{'orderItemHoles.width.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.width.description'|translate}}"
                    >
                      {{element['width']}}
                    </td>
                  </ng-container>

                  <!--depth-->
                  <ng-container matColumnDef="depth">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.depth.description'|translate}}"
                    >
                      {{'orderItemHoles.depth.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.depth.description'|translate}}"
                    >
                      {{element['depth']}}
                    </td>
                  </ng-container>

                  <!--radius-->
                  <ng-container matColumnDef="radius">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.radius.description'|translate}}"
                    >
                      {{'orderItemHoles.radius.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.radius.description'|translate}}"
                    >
                      {{element['radius']}}
                    </td>
                  </ng-container>

                  <!--collar-->
                  <ng-container matColumnDef="collar">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.collar.description'|translate}}"
                    >
                      {{'orderItemHoles.collar.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.collar.description'|translate}}"
                    >
                      {{element['collar']}}
                    </td>
                  </ng-container>

                  <!--joint-->
                  <ng-container matColumnDef="joint">
                    <th
                      class=""
                      mat-header-cell
                      *matHeaderCellDef
                      title="{{'orderItemHoles.joint.description'|translate}}"
                    >
                      {{'orderItemHoles.joint.title'|translate}}
                    </th>
                    <td
                      class=""
                      mat-cell
                      *matCellDef="let element"
                      data-title="{{'orderItemHoles.joint.description'|translate}}"
                    >
                      <div *ngIf="element['']"></div>

                      {{ element['joint']}}
                    </td>
                  </ng-container>
                </bc-templates-table-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--Dialog Actions-->
    <div footer-content>
      <!--Buttons-->
      <div class="buttons-container">
        <div class="right-buttons">
          <!--Cancel/Close -->
          <bc-atoms-button
            [label]="('actions.close'|translate)"
            [title]="('actions.cancel'|translate)"
            type="default"
            icon="cancel"
            display="block"
            size="small"
            (onButtonClicked)="onDismiss()"
          >
          </bc-atoms-button>
        </div>
      </div>
    </div>
  </bc-templates-modal-layout>
</div>
